import { CapoPlugin } from "/Users/kritikgarg/Documents/GitHub/arrify-nuxt-1/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];